export default {"src":"/_next/static/media/title.72a238d0.svg","height":42,"width":160};